import { z } from "zod";
import {
  MustContainNotContainSchema,
  MustMatchAllOrMatchNoneSchema,
  NumberRangeTypeFilterSchema,
  OptionalDateRangeSchema,
  TwoNumberRangeTypeFilterSchema,
} from "../common/common-filter-definitions-schema";
import { FLUMSchema } from "./flum-type-schema";
import { USWetlandSchema } from "./us-wetland-schema";
import { USZoneTypeSchema } from "./zone-type-schema";
import { USPropertyTypeSchema } from "./us-property-type-schema";

// --- Number Range Filter (area, percentage, basic) ---
export const USNumberRangeFilterSchema = z.object({
  id: z.string(),
  range: TwoNumberRangeTypeFilterSchema,
  type: NumberRangeTypeFilterSchema,
  rangeType: z.enum(["area", "percentage", "basic"]),
});

// --- Text Filter ---
export const USTextFilterSchema = z.object({
  id: z.string(),
  must: MustContainNotContainSchema,
  text: z.string(),
  type: z.literal("text"),
});

// --- Date Range Filter ---
export const USDateRangeFilterSchema = z.object({
  id: z.string(),
  range: OptionalDateRangeSchema,
  type: z.literal("date-range"),
});

// --- Multi Text Search Filter ---
export const USMultiTextSearchFilterSchema = z.object({
  id: z.string(),
  type: z.literal("multi-text-search"),
  must: MustMatchAllOrMatchNoneSchema,
  searchTags: z.array(z.string()),
});

// --- Discriminated Union for all US Parcel Filters ---
export const USParcelSearchFilterSchema = z.discriminatedUnion("id", [
  // Area, percentage, and basic number ranges
  USNumberRangeFilterSchema.extend({
    id: z.literal("lot-area-id"),
    rangeType: z.literal("area"),
  }),
  USNumberRangeFilterSchema.extend({
    id: z.literal("last-sale-date"),
    rangeType: z.literal("basic"),
  }),
  USNumberRangeFilterSchema.extend({
    id: z.literal("lot-cluster-area-id"),
    rangeType: z.literal("area"),
  }),
  USNumberRangeFilterSchema.extend({
    id: z.literal("us-total-wetlands-coverage-id"),
    rangeType: z.literal("percentage"),
  }),

  FLUMSchema,
  USPropertyTypeSchema,
  USWetlandSchema,
  USZoneTypeSchema,

  // Text filters
  USTextFilterSchema.extend({ id: z.literal("proprietor-name") }),
  USTextFilterSchema.extend({ id: z.literal("permitted-use-id") }),
  // Date range
  USDateRangeFilterSchema.extend({ id: z.literal("year-built") }),
  // Multi text search
  USMultiTextSearchFilterSchema.extend({ id: z.literal("zone-codes-id") }),
]);

// For an array of filters:
export const US_FILTER_DEFINITIONS_ARRAY = z.array(USParcelSearchFilterSchema);
